import { useIntl } from '@weenat/wintl';
import camelCase from 'lodash-es/camelCase';
import isNil from 'lodash-es/isNil';
import { useState } from 'react';
import { useClient } from '../../../ClientProvider';
import * as enums from '../../../enums';
import { mergeQueryState } from '../../../mergeState';
import useQuery from '../../../useQuery';
/**
 * Hooks that returns the current state of a Decitrait account configuration
 */
export const useDecitraitConfiguration = ({ organizationId, isSummary = false }) => {
    const { t } = useIntl();
    const client = useClient();
    const meRequest = useQuery(client.me.get());
    const orgRequest = useQuery(client.orgs.get(organizationId));
    const org = orgRequest.data;
    const me = meRequest.data;
    const [showLoginForm, setShowLoginForm] = useState(true);
    const hasOption = org?.activeOptions?.includes(enums.OptionCode.decitrait);
    const decitraitUserRequest = useQuery(client.decitrait.getUser({ organizationId: org?.id }), { refetchOnWindowFocus: false, enabled: hasOption });
    const resourcesRequest = useQuery(client.decitrait.getResources({ organizationId: org?.id }), { refetchOnWindowFocus: false });
    const decitraitErrors = decitraitUserRequest.error;
    const decitraitUser = decitraitUserRequest.data;
    const hasIncompleteUser = 
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore?.code?.message === '121'
    !isNil(decitraitErrors) && decitraitErrors.fieldErrors?.error?.code?.message === '121';
    const { isLoading } = mergeQueryState(orgRequest, meRequest, decitraitUserRequest, resourcesRequest);
    if (!me || !hasOption)
        return null;
    const epicureUsername = camelCase(org?.name || '');
    const allowUserConfigEdition = decitraitUser && !isSummary;
    const toggleBetweenLoginOrCreateUser = () => {
        setShowLoginForm(!showLoginForm);
    };
    const onUserConfigEditionSuccess = () => {
        decitraitUserRequest.refetch();
    };
    const onUserLoginOrCreationSuccess = () => {
        orgRequest.refetch();
        decitraitUserRequest.refetch();
    };
    const editUserConfigInitialValues = {
        areaId: decitraitUser?.areaId || '',
        departmentId: decitraitUser?.departmentId || '',
        town: decitraitUser?.town || '',
        postalCode: decitraitUser?.postalCode || '',
        responsable: decitraitUser?.responsable || '',
        vineyardCastle: decitraitUser?.vineyardCastle || ''
    };
    const configureUserInitialValues = {
        responsable: `${me.firstName} ${me.lastName}`,
        vineyardCastle: org?.name || ''
    };
    const createUserInitialValues = {
        epicureUsername,
        email: me.email,
        firstName: me.firstName,
        lastName: me.lastName
    };
    const userNotConfiguredMessage = hasIncompleteUser
        ? t('dss.decitrait.configStatus.account_not_configured')
        : t('dss.decitrait.configStatus.account_not_created');
    const isConfigComplete = !isNil(decitraitUser) && !hasIncompleteUser;
    return {
        allowUserConfigEdition,
        configureUserInitialValues,
        createUserInitialValues,
        editUserConfigInitialValues,
        epicureUsername,
        hasIncompleteUser,
        isConfigComplete,
        isLoading,
        onUserConfigEditionSuccess,
        onUserLoginOrCreationSuccess,
        org,
        showLoginForm,
        toggleBetweenLoginOrCreateUser,
        userNotConfiguredMessage
    };
};
